module.exports = __webpack_public_path__ + "static/media/marked-for-review.52a442b2.svg";